import { Component, OnInit,ViewChild,AfterViewInit } from '@angular/core';
import { LoaderService } from '../../../services/loader.service';
import { CommunitymanagerService } from '../cm-dashboard/communitymanager.service';
import { LeadService } from '../../lead/lead.service';
import { DesignerService } from '../../designer/designer.service';
import { Routes, RouterModule, Router, ActivatedRoute } from '@angular/router';
import { SchedulerService } from '../../scheduler/scheduler.service';
declare var $: any;

@Component({
  selector: 'app-cm-gm-mapping',
  templateUrl: './cm-gm-mapping.component.html',
  styleUrls: ['./cm-gm-mapping.component.css'],
  providers: [CommunitymanagerService, SchedulerService, DesignerService, LeadService]
})
export class CmGmMappingComponent implements OnInit {

  role: string;
  successalert = false;
  successMessage: string;
  errorMessage: string;
  erroralert = false;
  searchItem = "";


  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private leadService: LeadService,
    private loaderService: LoaderService,
  ) {
    this.role = localStorage.getItem('user');
  }

  ngOnInit() {
    this.getCMList("");
  }

  //to get CM list
  cm_list: any;
  gm_list: any;
  dm_list :any;
  getCMList(search: any) {
    this.loaderService.display(true);
    this.leadService.getCmListForCMGMMapping(search).subscribe(
      res => {
        this.loaderService.display(false);
        this.cm_list = res.community_manager;
        this.gm_list = res.city_gm;
        this.dm_list = res.design_manager
      },
      error => {
        this.loaderService.display(false);
      }
    )
  }

  // ngAfterViewInit(){
  //   setTimeout(function(){
  //     this.errorMessage = null;

  //   },3000)
  // }

  //to select GM
  selectCmId: any;
  assignedAgentId: any;
  onDropdownChange(CmId, value, rowid) {
    this.assignedAgentId = value;
    this.selectCmId = CmId;

  } 
  assignedAgentIdDm:any;
  onDropdownChangeDms(CmId, value, rowid) {
    this.assignedAgentIdDm = value;

    this.selectCmId = CmId;
  }


  //to map GM to CM
  assignLeadToAgent(CmId, index) {
    if (this.selectCmId == CmId) {
      this.loaderService.display(true);
      this.leadService.mapCMwithGM(CmId, this.assignedAgentId).subscribe(
        res => {
          // res= res.json();
          this.getCMList("");
          this.loaderService.display(false);
          this.successalert = true;
          $('#suc').show();
          setTimeout(function(){
            $('#suc').fadeOut('fast');
          },3000)
          this.successMessage = res.message;
          this.assignedAgentId = null;
          this.selectCmId = null;
        },
        error => {
          this.erroralert = true;
          this.errorMessage = <any>JSON.parse(error['_body']).message;
          $('#fail').show();
        setTimeout(function(){
          $('#fail').fadeOut('fast');
        },3000)
          this.getCMList("");
          this.loaderService.display(false);
        }
      )
    }
    else {
      this.erroralert = true;
      this.errorMessage = 'Select GM first';
      $('#fail').show();
      setTimeout(function(){
        $('#fail').fadeOut('fast');
      },3000)
    }
  }
  assignLeadToDm(CmId, index) {
    if (this.selectCmId == CmId) {
      this.loaderService.display(true);
      this.leadService.mapCMwithDM(CmId, this.assignedAgentIdDm).subscribe(
        res => {
          // res= res.json();
          this.getCMList("");
          this.loaderService.display(false);
          this.successalert = true;
          this.successMessage = res.message;
          this.assignedAgentId = null;
          this.selectCmId = null;
          $('#suc').show();
          setTimeout(function(){
            $('#suc').fadeOut('fast');
          },3000)
        },
        error => {
          this.erroralert = true;
          $('#fail').show();
          setTimeout(function(){
            $('#fail').fadeOut('fast');
          },3000)
          this.errorMessage = <any>JSON.parse(error['_body']).message;
          this.getCMList("");
          this.loaderService.display(false);
        }
      )
    }
    else {
      this.erroralert = true;
      this.errorMessage = 'Select DM first';
      $('#fail').show();
      setTimeout(function(){
        $('#fail').fadeOut('fast');
      },3000)
    }
  }

  //Remove assign GM
  selectedCm: any;
  assignedGm: any;
  assignedDm: any;
  getDataofRemoveDm(cmId,dmId){
    this.selectedCm = cmId;
    this.assignedDm= dmId;

  }

  removeGm() {
    this.loaderService.display(true);
    this.leadService.romoveAssignGm(this.selectedCm, this.assignedGm).subscribe(
      res => {
        this.getCMList("");
        $('#deleteGm').modal('hide');
        this.successalert = true;
        $('#suc').show();
        setTimeout(function(){
          $('#suc').fadeOut('fast');
        },3000)
        this.successMessage = <any>JSON.parse(res['_body']).message;
        this.loaderService.display(false);
      },
      error => {
        this.erroralert = true;
        $('#fail').show();
        setTimeout(function(){
          $('#fail').fadeOut('fast');
        },3000)
        this.errorMessage = <any>JSON.parse(error['_body']).message;
        this.loaderService.display(false);
      }
    )
  }
  removeDm() {
    this.loaderService.display(true);
    this.leadService.romoveAssignDm(this.selectedCm, this.assignedDm).subscribe(
      res => {
        this.getCMList("");
        $('#deleteDm').modal('hide');
        this.successalert = true;
        $('#suc').show();
        setTimeout(function(){
          $('#suc').fadeOut('fast');
        },3000)
        this.successMessage = <any>JSON.parse(res['_body']).message;
        this.loaderService.display(false);
      },
      error => {
        this.erroralert = true;
        $('#fail').show();
        setTimeout(function(){
          $('#fail').fadeOut('fast');
        },3000)
        this.errorMessage = <any>JSON.parse(error['_body']).message;
        this.loaderService.display(false);
      }
    )
  }



}



// WEBPACK FOOTER //
// ./src/app/platform/organisation/cm-gm-mapping/cm-gm-mapping.component.ts